<template>
  <div class="animated fadeIn">
    <loading :active.sync="disabledField"></loading>
    <notifications group="foo" />
    <b-row>
      <b-col sm="12" md="12" lg="12">
        <b-card>
          <div slot="header">
            Личный кабинет
          </div>
          <b-tabs>
            <b-tab title="Мои виджеты" active>
               <b-table :items="widgets" :fields="widgetFields">
                <template slot="time" slot-scope="data">
                  <strong v-bind:style="{color : dateColor(data.item.status)}">{{ data.item.time }}</strong>
                </template>
               </b-table>
            </b-tab>
            <b-tab title="Реквизиты" >

              <b-card sm="12" md="6" lg="12">
                <div slot="header">
                  Реквизиты
                </div>
                <b-form @submit="saveRequisites">

                  <b-form-group validated                    
                      label="Наименование организации"
                      label-for="companyName"
                      description="Начните вводить название своей организации, реквизиты будут заполнены автоматически. Либо заполните все поля ниже вручную.">

                      <vue-bootstrap-typeahead 
                        :data="companies"
                        v-model="companySearch"
                        :serializer="s => s.value"
                        @hit="selectCompany($event)"
                        placeholder="Наименование организации..."
                      >
                      <template slot="suggestion" slot-scope="{ data, htmlText }">
                        <span v-html="htmlText"></span>&nbsp;<small>ИНН: {{ data.data.inn }}</small>
                      </template>
                    </vue-bootstrap-typeahead>
                  </b-form-group>

                  <b-form-group validated
                    label="Краткое название"
                    label-for="shortName">
                    <b-form-input id="shortName" type="text" placeholder="" v-model="shortName"  required></b-form-input>
                  </b-form-group>

                  <b-form-group validated
                    label="Полное название"
                    label-for="fullName">
                    <b-form-input id="fullName" type="text" placeholder="" v-model="fullName"  required></b-form-input>
                  </b-form-group>

                  <b-form-group validated
                    label="ИНН"
                    label-for="inn">
                    <b-form-input id="inn" type="text" placeholder="" v-model="inn"  required></b-form-input>
                  </b-form-group>

                  <b-form-group validated
                    label="КПП"
                    label-for="kpp">
                    <b-form-input id="kpp" type="text" placeholder="" v-model="kpp"></b-form-input>
                  </b-form-group>

                  <b-form-group validated
                    label="ОГРН"
                    label-for="ogrn">
                    <b-form-input id="ogrn" type="text" placeholder="" v-model="ogrn"  required></b-form-input>
                  </b-form-group>

                  <b-form-group validated
                    label="Адрес"
                    label-for="address">
                    <b-form-input id="address" type="text" placeholder=""  v-model="address"  required></b-form-input>
                  </b-form-group>

                  <b-form-group validated
                    label="E-mail для документов"
                    label-for="email">
                    <b-form-input id="email" type="text" placeholder="" v-model="email"  required></b-form-input>
                  </b-form-group>

                  <b-form-group validated
                    label="Почтовый адрес"
                    label-for="mailAdress">
                    <b-form-input id="mailAddress" type="text" placeholder="" v-model="mailAddress"  required></b-form-input>
                  </b-form-group>

                  <div slot="footer">
                    <b-button type="submit" size="sm" variant="primary"><i class="fa fa-success"></i> Сохранить</b-button>
                  </div>
                </b-form>
              </b-card>
            </b-tab>

            <b-tab title="Пополнение баланса" >
              <h4>Создать счет</h4>
              <b-form inline @submit="remitPayment" class="mb-2">
                <label class="sr-only" for="payment_sum">Сумма платежа</label>
                <b-input-group prepend="&#8381;" class="mb-2 mr-sm-2 mb-sm-0">
                  <b-input v-model="paymentAmount"  id="payment_sum" placeholder="Сумма платежа" type="number"></b-input>
                </b-input-group>
                <b-button type="submit" :disabled="buttonBalanceEnabled" variant="primary">Создать счет-офферту</b-button>
              </b-form>
                <b-card>
                  В разделе "Мои виджеты" вы видите ежемесячную сумму расходов на платные виджеты и даты в которые будет происходить списание. 
                  Необходимо своевременно пополнять баланс. Для этого вы можете самостоятельно сформировать счет для оплаты. 
                  Сначала заполните Реквизиты юр.лица на соответствующей вкладке, а затем просто укажите сумму, и нажмите кнопку.
                </b-card> 
            </b-tab>

            <b-tab title="Платежи и списания" >
              <b-table id="payments-table" :items="payments" :fields="paymentFields" :total-rows="rows" :per-page="logPerPage" :current-page="logCurrentPage">
                <template slot="amount" slot-scope="data">
                  <strong v-bind:style="{color : logAmountColor(data.item)}">{{ data.item.amount }}</strong>
                </template>
              </b-table>
                <b-pagination
                  v-model="logCurrentPage"
                  :total-rows="rows"
                  :per-page="logPerPage"
                  aria-controls="payments-table"
                ></b-pagination>
            </b-tab>

            <b-tab title="Документы" >
              <b-table id="docs-table" :items="docs" :fields="docFields" :total-rows="rows" :per-page="docPerPage" :current-page="docCurrentPage">
                <template slot="download" slot-scope="data">
                  <b-button variant="primary" @click="downloadPdf(data.item._id, data.item.name)">Скачать документ</b-button>
                </template>
              </b-table>
              <b-pagination
                  v-model="docCurrentPage"
                  :total-rows="rows"
                  :per-page="docPerPage"
                  aria-controls="docstable"
                ></b-pagination>
            </b-tab>
            
          </b-tabs>

        </b-card>
      </b-col>
    </b-row><!--/.row--> 
    
  </div>
</template>

<script>
  import WidgetsService from '@/services/WidgetsService'
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  import widgetEvents from '@/views/widgets/Widget'
  import Default from '@/containers/DefaultContainer'

  import _ from 'underscore'
  import moment from 'moment'

  export default {
    mixins: [
        widgetEvents,
    ],
    name: 'Shop',
    components: {
      VueBootstrapTypeahead
    },
    data () {
      return {
        disabledField: false,
        companySearch: '',
        companies : [],
        shortName : '',
        fullName : '',
        inn : '',
        kpp : '',
        ogrn: '',
        address: '',
        email: '',
        mailAddress : '',

        paymentAmount : 0,
        widgets: [],
        payments : [],
        docs : [],

        widgetFields: [
          { key: 'name', label : 'Виджет'  },
          { key: 'price', label: 'Цена (руб)' },
          { key: 'count', label: 'Количество', },
          { key: 'total', label: 'Итого', },
          { key: 'time', label: 'Оплачен до:', }
        ], 
        paymentFields: [
          { key: 'type', label : 'Операция'  },
          { key: 'widget', label: 'Виджет' },
          { key: 'date', label: 'Дата операции', },
          { key: 'amount', label: 'Сумма', }
        ],
        docFields: [
          { key: 'name', label : 'Наименование'  },
          { key: 'download', label: 'Скачать' },
        ],

        logPerPage: 15,
        logCurrentPage: 1,

        docPerPage: 15,
        docCurrentPage: 1,
      }
    },
    mounted () {
      this.loadRequisites();      
    },
    computed: {
      authHeaders () {
        return {
          'Authorization': 'Token  a47a0ceab665604b1b8d994e3d5f7cf2fc3c363c',
          'Content-Type' :  'application/json',
          'Accept' :  'application/json',
        }
      },
    }, 
    methods: {
      downloadPdf(docId, name) {
        WidgetsService.getBillPdf(docId, response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', name + '.pdf');
          document.body.appendChild(link);
          link.click();
          this.disabledField = false;
        });   
      },
      async getCompanies(query) {
        const response = await WidgetsService.getInnData(query);    
        console.log(response.data.result.suggestions);
        this.companies = response.data.result.suggestions;
      },
      async getDocs(query) {
        const response = await WidgetsService.getDocs(); 
        this.docs = response.data;
      },
      // Список логов
      async getPaymentLogList() {
        const response = await WidgetsService.getPaymentsLog();     
        var logs = response.data;

        logs.forEach(log => {
          var type=''; var amount = '';
          switch(log.type){
            case 1 :
              type = 'Пополнение счета';
              amount = log.amount;
              break;
            case 2 :
              type = 'Оплата виджетов';
              amount = -log.amount;
              break;
          }

          this.payments.push({
            type: type,
            date : moment(log.date).format('DD.MM.YYYY HH:mm'),
            amount: amount,
            widget: log.widget,
            typeValue : log.type
          });
        });
      },
      // Список виджетов
      async getWidgetsList() {
        
        const trialTime = 14 * 24 * 3600 * 1000;
        const monthDiffTime = 30 * 24 * 3600 * 1000;
        const yearDiffTime = 12 * 30.5 * 24 * 3600 * 1000;

        const response = await WidgetsService.getWidgetsList();     
        var widgets = response.data;

        for(var i=0; i<widgets.length;i++){

          var price = 'Бесплатно'; 
          if(widgets[i].widget[0].price > 0) price = widgets[i].widget[0].price; 
          
          var total   = '-'; 
          var time    = '-';
          var status  = '';
          
          // Надо получить текущее количество пользователей
          var count = 0;

          // Высчитываем кол-во пользователей в зависимости от типа подписки
          var type = widgets[i].widget[0].type;

          if(type == 1) count = this.$root.user.usersCount; else count = 1;
          if(price > 0) total = price * count
          
          var isTrial = false;
          var createDate = widgets[i].createDate;
          var timeFromReg = moment().diff(createDate);

          if(timeFromReg < trialTime) isTrial = true;

           if(price > 0){
            if(isTrial){
              time = moment(createDate).add(14, 'days').format('DD.MM.YYYY');
              status = 'trial';
            } else {
              if(!widgets[i].lastPaymentDate){
                time = moment(createDate).add(14, 'days').format('DD.MM.YYYY');
                status = 'stop';
              } else {
                var timeFromLastPayment = moment().diff(widgets[i].lastPaymentDate);
                
                if(type == 1 || type == 2) {
                  time = moment(widgets[i].lastPaymentDate).add(30, 'days').format('DD.MM.YYYY');
                  if(widgets[i].lastPaymentDate > monthDiffTime) status = 'stop'; else status = 'good';
                } else if (type == 3) {
                  time = moment(widgets[i].lastPaymentDate).add(1, 'years').format('DD.MM.YYYY');
                  if(widgets[i].lastPaymentDate > yearDiffTime) status = 'stop'; else status = 'good';
                }
              }
            }
          }

          this.widgets.push({ 
            name: widgets[i].widget[0].name, 
            price: price, 
            count: count, 
            total: total, 
            time : time,
            status: status
          })
        };
      },
      dateColor (item) {
        if(item == 'trial') return 'orange';
        if(item == 'stop') return 'red';
        if(item == 'good') return 'green';
      },
      logAmountColor (item) {
        if(item.typeValue == 1) return 'green';
        if(item.typeValue == 2) return 'red';
      },
      
      selectCompany(company){
        this.inn = company.data.inn;
        this.kpp = company.data.kpp;
        this.ogrn = company.data.ogrn;
        this.fullName = company.data.name.full_with_opf;
        this.shortName = company.data.name.short_with_opf;
        this.address = company.data.address.unrestricted_value
      },
      async saveRequisites() {
        this.disabledField = true;
        
        const response = await WidgetsService.updateRequisites({
          shortName : this.shortName,
          fullName : this.fullName,
          inn : this.inn,
          kpp : this.kpp,
          ogrn: this.ogrn,
          address: this.address,
          email: this.email,
          mailAddress : this.mailAddress
        });
        this.disabledField = false;
        this.showAlert('success', 'Успех!', 'Настройки успешно сохранены!');
      },
      async loadRequisites() {
        this.disabledField = true;
        const response = await WidgetsService.getRequisites();     
        
        this.inn = response.data.inn;
        this.kpp = response.data.kpp;
        this.ogrn = response.data.ogrn;
        this.fullName = response.data.fullName;
        this.shortName = response.data.shortName;
        this.address = response.data.address
        this.email = response.data.email
        this.mailAddress = response.data.mailAddress

        this.disabledField = false;
      },
      async remitPayment() {
        if(this.paymentAmount <= 0){
          this.showAlert('Danger', 'Ошибка!', 'Невозможно пополнить баланс на 0 рублей');
          return;
        }
        this.disabledField = true;
        const billResponse = await WidgetsService.generateBillPdf(this.paymentAmount);
        WidgetsService.getBillPdf(billResponse.data._id, response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', billResponse.data.name + '.pdf');
          document.body.appendChild(link);
          link.click();
          this.disabledField = false;
        });     
      },
      async getUserInfo() {
        const response = await WidgetsService.getUserInfo();    
        this.user = response.data;
        this.$root.user = response.data;
      }
    },

    watch: {
      companySearch: _.debounce(function(query) { return this.getCompanies(query); }, 1000),
    },

    mounted: function() {
      this.getUserInfo();
      this.getWidgetsList();
      this.getPaymentLogList();
      this.getDocs();
      this.loadRequisites();
    },
    computed: {
      rows() {
        return this.payments.length
      },
      buttonBalanceEnabled() {
        var existRequisites = (this.inn != '' &&
        this.kpp != '' &&
        this.ogrn != '' &&
        this.fullName != '' &&
        this.shortName != '' &&
        this.address != '' &&
        this.email != '' &&
        this.mailAddress != '' )
        return (!existRequisites || this.paymentAmount <= 0);
      }
    }
  }
  
</script>